/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { makeStyles, withStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        ...theme.custom.applicationViewPage.tabs.subscriptions.styles
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        maxWidth: '1480px',
    },
    componentPadding: {
        paddingLeft: theme.spacing(7),
        paddingRight: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: 'auto',
            paddingRight: 'auto',
        }
    },
    actions: {
        display: 'flex',
        alignItems: "center",
        justifyContent: "flex-end"
    },
    deleteBtn: {
        height: theme.spacing(3.5),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(2),
        color: "#EA4C4D",
        borderRadius: theme.spacing(2),
        border: "1px solid",
        borderColor: "#F8C7C7",
        marginLeft: theme.spacing(1),
        backgroundRepeat: "no-repeat",
        backgroundSize: theme.spacing(2.5),
        backgroundPosition: "left",
        backgroundImage: "url('../../../themes/default/images/clear-red.svg')",
        "&:hover": {
            backgroundColor: "#FCEDED",
            color: "#EA4C4D",
            borderColor: "#EA4C4D",
            boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)"
        },
        "&:focus, &:active": {
            borderColor: "#EA4C4D",
            backgroundColor: "#EA4C4D !important",
            color: theme.palette.common.white,
            backgroundRepeat: "no-repeat",
            backgroundSize: theme.spacing(2.5),
            backgroundPosition: "left",
            backgroundImage: "url('../../../themes/default/images/clear-white.svg')",
        }
    },
    btnText: {
        textTransform: "initial",
        fontSize: 11,
        marginLeft: theme.spacing(1.625),
        fontWeight: 400
    },
    hoverBtn: {
        height: theme.spacing(4),
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(2),
        color: theme.palette.primary.main,
        borderRadius: theme.spacing(2),
        border: "1px solid",
        borderColor: "#CBCFF1",
        marginLeft: theme.spacing(1),
        backgroundRepeat: "no-repeat",
        backgroundPosition: "left",
        "&:hover": {
            backgroundColor: "rgb(204, 209, 242, 0.3)",
            color: theme.palette.primary.main,
            borderColor: "#A6B3FF",
            boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)"
        },
        "&:focus": {
            backgroundColor: `${theme.palette.primary.main} !important`,
            color: theme.palette.common.white,
            borderColor: theme.palette.primary.main
        }
    },
    editBtn: {
        height: theme.spacing(3.5),
        backgroundSize: theme.spacing(2.5),
        backgroundImage: "url('../../../themes/default/images/edit.svg')",
    },
    disabled: {
        opacity: 0.5,
    },
    title: {
        ...theme.custom.applicationViewPage.tabs.subscriptions.pageTitle
    },
    addApiBtn: {
        ...theme.custom.applicationViewPage.tabs.subscriptions.addApiBtn,
    },
    copyScopesBtn: {
        ...theme.custom.applicationViewPage.tabs.subscriptions.copyScopesBtn,
    },
    loaderContainer: {
        width: "cal(100%-75px)",
        height: "40vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    titleWrapper: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: theme.spacing(2),
        '& h5': {
            marginRight: theme.spacing(1),
        },
    },
    editDialogButton: {
        bottom: 15,
        textTransform: 'capitalize',
        fontFamily: 'GilmerMedium',
        fontSize: '13px',
        lineHeight: '16px',
        height: theme.spacing(5)
    },
    dialogRootStyle: {
        borderRadius: 15,
    },
    dialogContent: {
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
        overflowY: 'visible'
    },
    contentAlign: {
        textAlign: 'center',
    },
    primaryTitle: {
        fontFamily: 'GilmerBold',
        textAlign: "center",
        fontSize: '29px',
        lineHeight: '64px',
        color: '#222228',
        marginBottom: theme.spacing(1)
    },
    editPrimaryTitle: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(4)
    },
    editSecondaryTitle: {
        marginBottom: theme.spacing(2)
    },
    secondaryTitle: {
        textAlign: "center",
    },
    dialogActions: {
        display: "flex",
        justifyContent: "center",
        paddingTop: theme.spacing(5.25)
    },
    editDialogActions: {
        marginBottom: theme.spacing(1),
    },
    searchField: {
        marginTop: theme.spacing(4.5),
        marginBottom: theme.spacing(2),
        [`screen and @media (min-width: 540px)`]: {
            verticalAlign: 'top',
            horizontalAlign: 'right',
            position: 'absolute',
            right: '356px',
            minHeight: '40px',

        },
        '& .MuiTextField-root': {
            padding: '4px 3px 3px 3px',
            borderRadius: '21px',
            border: 'solid 1px #e6e7ec',
            height: '36px',
            width: '100%',
            minWidth: '240px',
            marginBottom: theme.spacing(3),

            '& :focus': {
                'borderColor': '#cfd0d6'
            },
            '& input::placeholder': {
                color: '#2222284d'
            }
        },
        '& .MuiInput-root': {
            paddingLeft: '15px',
            marginBottom: '1px',
            marginRight: theme.spacing(1),
            height: theme.spacing(4),
            backgroundImage: 'url("../../../themes/default/images/search.svg")',
            backgroundSize: "16px",
            backgroundPosition: "right",
            backgroundRepeat: "no-repeat",
            '& .MuiInputAdornment-positionStart .MuiInputAdornment-positionEnd': {
                display: 'none',
            }
        },
        '& .MuiInputAdornment-positionEnd .MuiIconButton-root.Mui-disabled': {
            color: 'transparent',
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled)::before ': {
            display: 'none',
        },
        '& .MuiInput-underline::after': {
            display: 'none',
        },
        '& .MuiInput-underline::before ': {
            display: 'none',
        },
        '& .MuiInput-underline': {
            borderBottom: "none"
        }
    },
    dropdownStyle: {
        backgroundColor: "#fff",
        boxSizing: "border-box",
        width: "auto",
        border: "1px solid #DEE0E7",
        borderRadius: "5px",
        boxShadow: "0 5px 10px -3px rgba(50,50,77,0.1)",
        color: "#222228",
        marginTop: '0.25rem'
    },
    selectDropDownSm: {
        height: theme.spacing(4.2),
        width: "80%",
        borderRadius: "5px",
        background: "linear-gradient(180deg, #ffffff 0%, #f7f7f9 100%)",
        boxShadow: "inset 0 0 0 1px #dee0e7, 0 1px 1px 0 rgba(0, 0, 0, 0.06)",
        cursor: "pointer",
        border: 1,
        "&:active": {
            background: "linear-gradient(180deg, #ffffff 0%, #f7f7f9 100%)",
            boxShadow: "inset 0 0 0 1px #a6b3ff, 0 1px 1px 0 rgba(0, 0, 0, 0.06)",
            border: "1px solid #5567d5",
        },
        "&:focused": {
            background: "linear-gradient(180deg, #ffffff 0%, #f7f7f9 100%)",
            boxShadow: "inset 0 0 0 1px #a6b3ff, 0 1px 1px 0 rgba(0, 0, 0, 0.06)",
            border: "1px solid #5567d5 !important",
        },
        "& .MuiSelect-selectMenu": {
            "& .TextSpan": {
                color: '#222228'
            }
        },
    },
    subscribeBtn: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        fontSize: 13,
        textTransform: 'capitalize',
        fontFamily: 'GilmerMedium'
    },
    infoIcon: {
        color: '#5567D5',
    },
    noDataInfo: {
        backgroundColor: '#F0F1FB',
        borderLeftStyle: 'solid',
        borderLeftColor: '#5567D5',
        maxWidth: '500px',
        padding: theme.spacing(1.8),
    },
    noDataText: {
        fontFamily: 'GilmerMedium',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[200],
    },
    apiNameColumn: {
        cursor: 'pointer',
        color: '#5567D5'
    },
    bottomSpace: {
        marginBottom: theme.spacing(6)
    },
    disabledElement: {
        pointerEvents: 'none'
    },
    containerList: {
        '& .MuiPaper-root:first-child' : {
            backgroundColor: theme.custom.applicationViewPage.tabs.subscriptions.styles.backgroundColor,
            '& .MuiTable-root:first-child' : {
                '& .MuiTableBody-root' : {
                    backgroundColor: theme.custom.applicationViewPage.tabs.subscriptions.styles.backgroundColor,
                }
            }
        }
    },
    displayInline: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        paddingLeft: theme.spacing(0.5),
    },
    selectBox: {
        height: theme.spacing(5),
        width: theme.spacing(30),
        borderRadius: "5px",
        background: "linear-gradient(180deg, #ffffff 0%, #f7f7f9 100%)",
        boxShadow: "inset 0 0 0 1px #dee0e7, 0 1px 1px 0 rgba(0, 0, 0, 0.06)",
        cursor: "pointer",
        border: 1,
        "&:active": {
            background: "linear-gradient(180deg, #ffffff 0%, #f7f7f9 100%)",
            boxShadow: "inset 0 0 0 1px #a6b3ff, 0 1px 1px 0 rgba(0, 0, 0, 0.06)",
            border: "1px solid #5567d5",
        },
        "&:focused": {
            background: "linear-gradient(180deg, #ffffff 0%, #f7f7f9 100%)",
            boxShadow: "inset 0 0 0 1px #a6b3ff, 0 1px 1px 0 rgba(0, 0, 0, 0.06)",
            border: "1px solid #5567d5 !important",
        },
        "& .MuiSelect-selectMenu": {
            "& .TextSpan": {
                color: '#222228'
            }
        },
    },
    policyGridItem: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: theme.spacing(1),
    },
    cardContent: {
        marginBottom: theme.spacing(1),
        transition: "0.2s",
        marginRight: theme.spacing(1),
        borderRadius: "16px",
        height: "195px",
        paddingLeft: theme.spacing(2),
        boxShadow: "0px 0px 1px 0px #8D91A3, 0px 1px 2px 0px #CBCEDB",
        cursor: "pointer",
    },
    cardHeaderTitle: {
        overflowWrap: "anywhere",
        ...theme.custom.elements.apiCard.title,
        marginTop: theme.spacing(2),
        fontWeight: "bold",
        fontSize: 16,
        textAlign: "center",
        marginRight: theme.spacing(2),
    },
    cardBorder: {
        border: "1px solid #cccccc",
    },
    cardBorderSelected: {
        border: "2px solid #A6B3FF",
        boxShadow: "none",
    },
    policyCardListItem: {
        display: 'list-item',
        padding: "4px",
        paddingLeft: "20px",
        '&::before': {
            content: '"•"',
            position: 'absolute',
            left: '0',
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: '16px',
            color: '#A6B3FF',
        },
    },
    backToSubscriptionBtn: {
        textTransform: "initial",
        fontSize: 14,
        fontWeight: 400,
        marginLeft: theme.spacing(-1),
    },
    gridItem: {
        textAlign: "left",
    },
    subscriptionsTitle: {
        ...theme.custom.applicationViewPage.tabs.subscriptions.pageTitle,
        marginBottom: theme.spacing(3),
    },
    selectorBox: {
        display: 'flex',
        flexDirection: 'row',
    },
    selector: {
        marginRight: theme.spacing(2),
    },
    btnBox: {
        marginLeft: theme.spacing(-2),
    },
    policySelectorGridItem: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: theme.spacing(1),
        marginLeft: theme.spacing(0),
    },
    policyCardTypography: {
        fontWeight: "bold"
    },
    autoComplete:{
        height: theme.spacing(8),
        width: theme.spacing(30),
        cursor: "pointer",
        marginBottom: theme.spacing(-2),
       "& .MuiAutocomplete-inputRoot": {
         "& .MuiAutocomplete-input": {
            padding: theme.spacing(0.5)
         }
       }
    },
    autoCompleteTextField: {
        height: theme.spacing(3),
    },
}));
